import { ErpLogsGridView } from '~/components/system/erp-logs';
import { PageContainer } from '~/components/page-container';

export function ErpLogs() {
	return (
		<PageContainer>
			<ErpLogsGridView />
		</PageContainer>
	);
}
